import React, { useState } from "react";
import './Changedisplayname.css';


const Changedisplayname = () =>{
    const [displayName, setDisplayName] = useState('');


    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the submit logic (e.g., API call or update state)
        console.log('New Display Name:', displayName);
      };

return(
    <div className="changedisplayname-container">
    <div className="changedisplayname-box">
      <h2 className="displayname-heading">Change Display Name</h2>
      <form onSubmit={handleSubmit}>
        <div className="displayname-input-container-floating">
          
          <input
            type="text"
            id="displayName"
            placeholder=""
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            required
          />
          <label htmlFor="displayName">New Display Name</label>
        </div>

        <button type="submit"  disabled={!displayName.trim()} className="displayname-submit-btn">Submit</button>
      </form>
    </div>
  </div>
)
}
export default Changedisplayname;